import { FC } from "react";
import './index.css'

const NotFound: FC = () => {
    return (
        <div className="not-found">
            <h1>404</h1>
            <h2>Page not found</h2>
            <p>Sorry, the page you are looking for does not exist.</p>
            <a href="/">Go back to home</a>
        </div>
    )
}
export default NotFound;